<template>
  <section class="jd-content hp-animate" v-if="job || loading">
    <div v-if="loading" class="jd-content__skeleton">
      <content-loader viewBox="0 0 600 200" primaryColor="#f1f5f9" secondaryColor="#e2e8f0">
        <rect x="0" y="0" rx="4" ry="4" width="160" height="14" />
        <rect x="0" y="28" rx="4" ry="4" width="100%" height="8" />
        <rect x="0" y="44" rx="4" ry="4" width="95%" height="8" />
        <rect x="0" y="60" rx="4" ry="4" width="90%" height="8" />
        <rect x="0" y="88" rx="4" ry="4" width="85%" height="8" />
        <rect x="0" y="104" rx="4" ry="4" width="92%" height="8" />
      </content-loader>
    </div>

    <template v-else-if="job">
      <div class="jd-skills" v-if="job.skills && job.skills.length">
        <h2 class="jd-content__heading">Skills</h2>
        <div class="jd-skills__list">
          <span v-for="(skill, i) in job.skills" :key="i" class="jd-chip">{{ skill }}</span>
        </div>
      </div>

      <div class="jd-skills" v-if="job.sublocations && job.sublocations.length">
        <h2 class="jd-content__heading">Sublocations</h2>
        <div class="jd-skills__list">
          <span v-for="(loc, i) in job.sublocations" :key="i" class="jd-chip jd-chip--muted">{{ loc }}</span>
        </div>
      </div>

      <div class="jd-content__body" v-html="job.job_description"></div>
    </template>
  </section>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'JobDetailContent',
  components: { ContentLoader },
  props: {
    job: { type: Object, default: null },
    loading: { type: Boolean, default: true },
  },
};
</script>
